import { WalletTypeEnum } from '@libs/backend-common';
import { EmptyState, Typography } from '@libs/components';
import { WalletInfoItem } from '@libs/types';
import { useState } from 'react';
import { DesertedIcon } from 'src/assets';
import { balanceCurrencyOptions } from 'src/constants';
import { BuyCryptoChooseAssetLoader } from 'src/content-loaders';
import { useCurrency, useTranslation, useWalletInfo } from 'src/hooks';
import CryptoAssetItem from '../crypto-asset-item/CryptoAssetItem';

import {
  AssetsTitleWrapper,
  AssetsWrapper,
  BalanceCurrencyTabsWrapper,
  BalanceCurrencyWrapper,
  ContentContainer,
  CustomTabs,
  CustomSearchInput,
} from './styles';

type CryptoAssetselectionProps = {
  handleAssetSelect: (val?: WalletInfoItem) => void;
};
const SellCryptoAssetSelection: React.FC<CryptoAssetselectionProps> = ({
  handleAssetSelect,
}) => {
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState('');

  const { currency } = useCurrency();

  const [balanceCurrency, setBalanceCurrency] = useState(
    balanceCurrencyOptions.find((e) => e.value == currency) ||
      balanceCurrencyOptions[0]
  );

  const handleBalaceCurrencyTab = (tabId: string | number) => {
    const selectedActiveTab = balanceCurrencyOptions.find(
      (tab) => tab.id === tabId
    );

    if (selectedActiveTab) {
      setBalanceCurrency(selectedActiveTab);
    }
  };
  const { response, loading } = useWalletInfo({
    walletType: WalletTypeEnum.NON_ZERO_ASSETS,
    isCrypto: true,
    valueAssetCode: balanceCurrency.value,
  });

  const filteredAssets = response?.getWalletInfoNew.filter(
    (asset) =>
      asset.name.toLowerCase().includes(searchValue.toLowerCase()) ||
      asset.code.toLowerCase().includes(searchValue.toLowerCase())
  );

  return (
    <ContentContainer>
      <AssetsTitleWrapper>
        <Typography type="headline" fontFamily="primaryBold">
          {t('sell_choose_asset_title')}
        </Typography>
      </AssetsTitleWrapper>

      <CustomSearchInput
        value={searchValue}
        onChangeText={setSearchValue}
        placeholder={t('common_search')}
      />

      <BalanceCurrencyWrapper>
        <Typography type="bodyButton" fontFamily="primaryMedium">
          {t('withdraw_coins_value')}
        </Typography>
        <BalanceCurrencyTabsWrapper>
          <CustomTabs
            tabs={balanceCurrencyOptions}
            activeTab={balanceCurrency.id}
            handleTabClick={handleBalaceCurrencyTab}
          />
        </BalanceCurrencyTabsWrapper>
      </BalanceCurrencyWrapper>
      {filteredAssets?.length ? (
        <AssetsWrapper>
          {filteredAssets?.map((asset) => {
            const handleAssetClick = () => {
              handleAssetSelect(asset);
            };

            return (
              <CryptoAssetItem
                key={asset.code}
                testId={'asset-' + asset.code}
                icon={asset.iconUrl}
                text={asset.name}
                description={asset.code}
                disabled={asset.isDisabled}
                amount={asset.amount}
                balanceCurrency={balanceCurrency.value}
                rate={String(asset.value)}
                onClick={handleAssetClick}
                isBalanceVisible
              />
            );
          })}
        </AssetsWrapper>
      ) : null}
      <>
        {!filteredAssets?.length && (
          <EmptyState
            title={t('error_asset_not_found')}
            img={DesertedIcon}
            loading={loading}
          />
        )}
        {loading && <BuyCryptoChooseAssetLoader shouldShowCircleIcon={false} />}
      </>
    </ContentContainer>
  );
};

export default SellCryptoAssetSelection;
